export default {"src":"/_next/static/media/instagram_hover.25872508.svg","height":44,"width":45};